import {ModuleConfiguration} from "../router/model/UserPermission";
import {BrandServiceModuleName, ThemeColourPickerModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, UtilsModuleName} from "../utils/names/requiredModulesNames";

export const BrandServiceModuleConfig = new ModuleConfiguration(BrandServiceModuleName,
    [AngularJsMaterialModuleName, BrandServiceModuleName, UtilsModuleName, ThemeColourPickerModuleName]);